export const fieldNames = {
  name: "Name",
  dataDomain: 'Data Domain',
  status: 'Status',
  definition: 'Definition',
  dataType: 'Data Type'
}

export const selectOptions = [
  {
    text:'All',
    value: 'all'
  },
  {
    text:'New',
    value: 'new'
  },
  {
    text:'Approved',
    value: 'approved'
  },
  {
    text:'Proposed',
    value: 'proposed'
  },
  {
    text:'Inactive',
    value: 'inactive'
  }
]

export const options = [
  {
    text:'New',
    value: 'new'
  },
  {
    text:'Approved',
    value: 'approved'
  },
  {
    text:'Proposed',
    value: 'proposed'
  },
  {
    text:'Inactive',
    value: 'inactive'
  }
]

export const getSortStatusName = status => selectOptions.filter( item => item.value === status ).map( item => item.text )[0]